import type { TFunction } from 'i18next'

import { createSRTColumnHelper } from '@/shared/components/master-table'
import { formatNumber, NumberFormats } from '@/shared/tools/locale'

import {
	AddIdxCell,
	MulIdxCell,
	SourceFamilyIdCell,
} from '../ui/AnchorProductTableCells'

const columnHelper = createSRTColumnHelper()

export const getColumns = (t: TFunction) => [
	columnHelper.accessor('sku', {
		header: t('field_schema_sku', { ns: 'fields' }),
		description: t('field_schema_sku', { ns: 'fields' }),
		size: 90,
	}),
	columnHelper.accessor('title', {
		header: t('field_schema_product_name', { ns: 'fields' }),
		description: t('field_schema_product_name', { ns: 'fields' }),
	}),
	columnHelper.accessor('sales_entity_name', {
		header: t('field_schema_pos_id', { ns: 'fields' }),
		description: t('field_schema_pos_id', { ns: 'fields' }),
		size: 100,
	}),
	columnHelper.display({
		header: t('field_schema_family_id', { ns: 'fields' }),
		description: t('field_schema_family_id', { ns: 'fields' }),
		size: 140,
		Cell: () => <SourceFamilyIdCell />,
	}),
	columnHelper.accessor('cost', {
		header: t('field_schema_cost', { ns: 'fields' }),
		description: t('field_schema_cost', { ns: 'fields' }),
		size: 80,
		Cell: ({ cellValue }) => (
			<div>{formatNumber(cellValue, NumberFormats.Fixed)}</div>
		),
	}),
	columnHelper.accessor('last_price', {
		header: t('field_schema_last_price', { ns: 'fields' }),
		description: t('field_schema_last_price', { ns: 'fields' }),
		size: 80,
		Cell: ({ cellValue }) => (
			<div>{formatNumber(cellValue, NumberFormats.Fixed)}</div>
		),
	}),
	columnHelper.display({
		header: t('mul_idx', { ns: 'fields' }),
		description: t('mul_idx', { ns: 'fields' }),
		size: 100,
		Cell: () => <MulIdxCell />,
	}),
	columnHelper.display({
		header: t('add_idx', { ns: 'fields' }),
		description: t('add_idx', { ns: 'fields' }),
		size: 100,
		Cell: () => <AddIdxCell />,
	}),
]
